let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ISrPM")).then(() => parcelRequire('eB9ra'));